// removed by extract-text-webpack-plugin
module.exports = {"aliCard":"HomePage__aliCard__16Tmc","Blog":"HomePage__Blog__SNOsn","container":"HomePage__container__1jA_D","divRow":"HomePage__divRow__cy_xL","br_for_mobile":"HomePage__br_for_mobile__2oUkh","editordiv":"HomePage__editordiv__2XW3n","textArea":"HomePage__textArea__2U8ha","newblogdiv":"HomePage__newblogdiv__4gAKy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePage/HomePage.css
// module id = 471
// module chunks = 3